import validation from './validation';

export default {
  ...validation,
  //Common
  'button.delete': 'Delete',
  'button.cancel': 'Cancel',
  'button.continue': 'Continue',
  'button.submit': 'Submit',
  'button.save': 'Save',
  'button.edit': 'Edit',
 

  'label.firstName': 'First Name',
  'label.lastName': 'Last Name',
  'label.email': 'Email Address',
  'label.password': 'Password',
  'label.confirmPassword': 'Confirm Password',

  //Header
  'header.overview': 'Overview',
  'header.support': 'Support',
  'header.settings': 'Settings',
  'header.logout': 'Log Out',
  'header.account': 'Account',
  'header.newAccount': '+ Open Account',
  'header.accountStatements': 'Account Statements',

  //Sign Up
  'signup.header': 'Sign Up',
  'signup.passwordRequirement.header': 'Password must contain:',
  'signup.passwordRequirement.lowerCase': '1 lowercase letter',
  'signup.passwordRequirement.upperCase': '1 uppercase letter',
  'signup.passwordRequirement.special': '1 special character (i.e. #, $, %, !)',
  'signup.passwordRequirement.charactersNumber': '8 characters',
  'signup.terms.text': 'I agree to the',
  'signup.terms.link': 'terms and conditions',
  'signup.signIn.text': 'Already have an account?',
  'signup.signIn.link': 'Sign In',

  //Login
  'login.label.email': 'Email',
  'login.label.password': 'Password',
  'login.button.forgotPassword': 'Forgot password?',
  'login.button.logIn': 'Log in',
  'login.button.signUp': 'Create a new account',

  //Forgot Password
  'forgotPassword.header': 'Reset Password',
  'forgotPassword.email.placeholder': 'Enter your email',
  'forgotPassword.button.resetPassword': 'Reset Password',
  
  //Reset Password
  'resetPassword.label.password': 'New password',
  'resetPassword.label.confirmPassword': 'Confirm password',
  'resetPassword.button.reset': 'Reset password',

  //Dashboard
  'dashboard.banner.title': 'Welcome back!',
  'Select Project':'Select Project',
  'clm':'clm',
  'om':'om',
  'a4a':'a4a'
};
